import { initializeStores } from 'stores/mobx/common/stores-init';

const stores = initializeStores();

export type Stores = typeof stores;

export default stores;
